export type SortDirection = "asc" | "desc" | "";

export interface ISortState {
	column: string;
	direction: SortDirection;
}

export class SortState implements ISortState {
	column = "_id"; // _id by default
	direction: SortDirection = "asc"; // asc by default;

	constructor(column?: string, direction?: SortDirection) {
		this.column = column;
		this.direction = direction;
	}
}

export class SortStatePostgres implements ISortState {
	column = "id"; // _id by default
	direction: SortDirection = "asc"; // asc by default;
}

export interface ISortView {
	sorting: SortState;
	ngOnInit(): void;
	sort(column: string): void;
}
